import type { PublicJob } from '@/types/public-share'
import {
  EMPLOYMENT_TYPE_LABELS,
  WORK_MODE_LABELS,
  formatOpportunityJobPlace,
  normalizeSelectEnumKey,
} from '@/utils/opportunity-job-meta'
import { formatRelativeTimeInDays } from '@/utils/relative-time'

/** Location, employment type, work mode, and optional salary for public job surfaces. */
export function formatPublicJobMeta(
  job: PublicJob,
  options: { includeSalary?: boolean } = {},
): string | null {
  const parts: string[] = []
  const place = formatOpportunityJobPlace(job)
  if (place) parts.push(place)
  const et = normalizeSelectEnumKey(job.employment_type, EMPLOYMENT_TYPE_LABELS)
  const wm = normalizeSelectEnumKey(job.work_mode, WORK_MODE_LABELS)
  if (et) parts.push(EMPLOYMENT_TYPE_LABELS[et])
  if (wm) parts.push(WORK_MODE_LABELS[wm])
  if (options.includeSalary) {
    const salary = job.salary_display?.trim()
    if (salary) parts.push(salary)
  }
  return parts.length ? parts.join(' · ') : null
}

/** Same Posted / Updated wording as logged-in job cards. */
export function formatPublicJobPostedLabel(job: Pick<PublicJob, 'published_at' | 'updated_at'>): string | null {
  const publishedAt = job.published_at?.trim()
  if (publishedAt) {
    const relative = formatRelativeTimeInDays(publishedAt)
    return relative ? `Posted ${relative}` : null
  }
  if (job.updated_at?.trim()) {
    return `Updated ${new Date(job.updated_at).toLocaleDateString()}`
  }
  return null
}
